import { memo } from 'react';
import { IconProps } from '../types';

export const ODPSmallLogo = memo(({ className, style }: IconProps) => {
  return (
    <svg
      className={className}
      style={{ display: 'block', width: '100%', height: '100%', ...style }}
      viewBox="116.5 4.5 26 40"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ODP Small Logo Dark"
    >
      <path
        d="M137.204 4.5L142.5 4.5L121.917 44.5H116.5L137.204 4.5Z"
        fill="url(#paint0_linear_small_2962_9565)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_small_2962_9565"
          x1="131.667"
          y1="4.5"
          x2="131.667"
          y2="44.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0078D6" />
          <stop offset="1" stopColor="#17E3CC" />
        </linearGradient>
      </defs>
    </svg>
  );
});
